import commonUtil from '../../../../utils/commonUtil';

export const CATEGORYSTATUS_LOAD = 'CATEGORYSTATUS_LOAD';
export const CATEGORYSTATUS_LOAD_SUCCESS = 'CATEGORYSTATUS_LOAD_SUCCESS';
export const CATEGORYSTATUS_LOAD_FAIL = 'CATEGORYSTATUS_LOAD_FAIL';

export function CheckEventCreateValidOld(eventType, profileId) {
  const _eventCategoryInput = {};
  _eventCategoryInput.brand = commonUtil.getBrand();
  _eventCategoryInput.channel = commonUtil.getChannel();
  _eventCategoryInput.profileId = profileId === undefined ? '' : profileId;
  _eventCategoryInput.eventType = eventType;
  return {
    types: [CATEGORYSTATUS_LOAD, CATEGORYSTATUS_LOAD_SUCCESS, CATEGORYSTATUS_LOAD_FAIL],
    promise: client => client.post('/api/isEventEligibleToCreate', {
      data: (_eventCategoryInput),
    }),
  };
}

export function CheckEventCreateValid(eventType, profileId) {
  const _eventCategoryInput = {};
  _eventCategoryInput.brand = commonUtil.getBrand();
  _eventCategoryInput.channel = commonUtil.getChannel();
  _eventCategoryInput.profileId = profileId === undefined ? '' : profileId;
  _eventCategoryInput.eventType = eventType;
  return commonUtil.triggerServerRequest({ url: '/api/isEventEligibleToCreate', method: 'POST', data: _eventCategoryInput });
}
